<template>
  <div>
    <div class="page-title">New Notification</div>
    <Form v-model="form" :submit="create" btnText="Add Notification" />
  </div>
</template>

<script>
import Form from "./_form.notifications.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.Notification.new();
      this.form = data;
    },
    async create() {
      await this.$api.Notification.create(this.form);
      this.$router.push("/widgets/notifications");
    },
  },
};
</script>

<style></style>
